import { actionCreatorFactory, AsyncActionCreators } from 'typescript-fsa';
import {
    GetResponseOrderParts,
    DesignSet,
    ArrowType,
    OrderType,
    OrdermadeArrowPartsName,
    GetResponseFamilyCrestColors,
} from '@app/react/const/type';

const actionCreator = actionCreatorFactory('partsGetAction');

export interface IAPIDataGetParam {
    arrowType: ArrowType;
    orderType: OrderType;
    selectItems: DesignSet;
}

export interface IAPIDataGetResult {
    param: GetResponseOrderParts;
}

export interface IAPIDataGetError {
    message: string;
}

interface IAPIDataBasicActions {
    shaft: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    feather: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    thread: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    kebiki: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    nock: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    arrowhead: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    arrowlength: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    unit: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    arrowinsert: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    twine: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    lame: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    carving: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    typezero: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    decoration: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
    featherinside: AsyncActionCreators<IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError>;
}

export interface IAPIDataGetFamilyCrestResult {
    familycrest: GetResponseOrderParts;
    familycrestColor: GetResponseFamilyCrestColors;
}

interface IAPIDataGetActions extends IAPIDataBasicActions {
    familycrest: AsyncActionCreators<
    IAPIDataGetParam, IAPIDataGetFamilyCrestResult, IAPIDataGetError
    >;
}

const basicActionNames: (keyof IAPIDataBasicActions)[] = [
    OrdermadeArrowPartsName.Shaft,
    OrdermadeArrowPartsName.Feather,
    OrdermadeArrowPartsName.Thread,
    OrdermadeArrowPartsName.Kebiki,
    OrdermadeArrowPartsName.Nock,
    OrdermadeArrowPartsName.Arrowhead,
    OrdermadeArrowPartsName.Arrowlength,
    OrdermadeArrowPartsName.Unit,
    OrdermadeArrowPartsName.Arrowinsert,
    OrdermadeArrowPartsName.Twine,
    OrdermadeArrowPartsName.Lame,
    OrdermadeArrowPartsName.Carving,
    OrdermadeArrowPartsName.Typezero,
    OrdermadeArrowPartsName.Decoration,
    OrdermadeArrowPartsName.Featherinside,
];
const x = basicActionNames.reduce((acc: IAPIDataBasicActions, partsName) => ({
    ...acc,
    [partsName]: actionCreator.async<
    IAPIDataGetParam, IAPIDataGetResult, IAPIDataGetError
    >(partsName),
}), {} as IAPIDataBasicActions);

export const apiGetActions: IAPIDataGetActions = {
    ...x,
    familycrest: actionCreator.async<
    IAPIDataGetParam, IAPIDataGetFamilyCrestResult, IAPIDataGetError
    >('familyCrest'),
};
